import React, { useState, useEffect } from 'react';
import { ChevronDown, ChevronUp, X, ChevronLeft, ChevronRight } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import ReactDOM from 'react-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fallback data pokud API selže
const fallbackWorks = [
  {
    id: 1,
    title: "Kompletní čištění interiéru + exteriér + kola",
    date: "14. dubna 2026",
    shortDesc: "Kompletní čištění interiéru, mytí exteriéru a umytí kol s oživením pneumatik.",
    mainImage: "https://i.ibb.co/wNQXpNsM/IMG-7893.jpg",
    detailImages: [
      "https://i.ibb.co/wNQXpNsM/IMG-7893.jpg",
      "https://i.ibb.co/Mx9nR1B5/IMG-7921.jpg",
      "https://i.ibb.co/R44PMdDz/IMG-7903.jpg",
      "https://i.ibb.co/chW2YBWj/IMG-7934.jpg",
      "https://i.ibb.co/3yk0JQy4/IMG-7898.jpg",
      "https://i.ibb.co/Fbv3fzcH/IMG-7927.jpg",
      "https://i.ibb.co/x8gPpnzh/IMG-7896.jpg",
      "https://i.ibb.co/cSyDx0V1/IMG-7924.jpg",
      "https://i.ibb.co/mrhSXd7w/IMG-7894.jpg",
      "https://i.ibb.co/d4HqZcdF/IMG-7922.jpg",
      "https://i.ibb.co/rff9Q9gb/IMG-7907.jpg",
      "https://i.ibb.co/bjG9XktT/IMG-7926.jpg",
      "https://i.ibb.co/LzS6rh8G/IMG-7909.jpg",
      "https://i.ibb.co/wZ1ym2Yf/IMG-7920.jpg",
      "https://i.ibb.co/TMfL7Dp1/IMG-7914.jpg",
      "https://i.ibb.co/rKhF3Rrz/IMG-7938.jpg",
      "https://i.ibb.co/ynKB2T5m/IMG-7913.jpg",
      "https://i.ibb.co/GvHQbFLT/IMG-7941.jpg",
      "https://i.ibb.co/x8g4h0VX/IMG-7917.jpg",
      "https://i.ibb.co/gLDFHnjy/IMG-7939.jpg"
    ],
    fullDesc: `Ruční mytí rámů
Důkladné vysátí podlahy, koberečků, sedadel a kufru
Vyčištění a impregnace sedadel, volantu a všech kožených dílů
Vyčištění koberečků, podlahy a kufru parou
Čištění a ošetření plastů a přístrojové desky
Mytí a leštění oken
Vyčištění stropnice
Provonění interiéru
Umytí exteriéru
Umytí kol
Oživení pneumatik`
  },
  {
    id: 2,
    title: "Kompletní čištění interiéru + exteriér",
    date: "14. března 2026",
    shortDesc: "Kompletní čištění interiéru, mytí exteriéru s voskovou ochranou a umytí kol s oživením pneumatik.",
    mainImage: "https://i.ibb.co/jvfK2945/651701775-122125892157027995-6147240211208202219-n.jpg",
    detailImages: [
      "https://i.ibb.co/jvfK2945/651701775-122125892157027995-6147240211208202219-n.jpg",
      "https://i.ibb.co/BXkJWrd/651266923-122125892037027995-5023327195849489967-n.jpg",
      "https://i.ibb.co/rRdZxbFG/651246827-122125892079027995-4941517423939959070-n.jpg",
      "https://i.ibb.co/wF54J6qj/651040210-122125892055027995-5654747313107793796-n.jpg",
      "https://i.ibb.co/DHfsSHVZ/651932990-122125892013027995-5724565847183783616-n.jpg",
      "https://i.ibb.co/xKX4DtQv/650733593-122125892145027995-3443033318544600649-n.jpg",
      "https://i.ibb.co/QFD8mp08/652576146-122125892199027995-4458511419646728697-n.jpg",
      "https://i.ibb.co/MkVyW6YD/653401249-122125892097027995-6537962067416943803-n.jpg",
      "https://i.ibb.co/YB14zRsy/651193579-122125892355027995-7256274408984895379-n.jpg",
      "https://i.ibb.co/gZb0gkTw/650738456-122125892265027995-7339499126569295594-n.jpg",
      "https://i.ibb.co/FLWS5dDq/651267790-122125892175027995-4349457971333003396-n.jpg",
      "https://i.ibb.co/G4TrfHzx/651071086-122125891803027995-3126430053812434497-n.jpg"
    ],
    fullDesc: `Ruční mytí rámů, důkladné vysátí podlahy, koberečků, sedadel a kufru.
Tepování sedadel a podlahy.
Čištění a ošetření plastů a přístrojové desky.
Mytí a leštění oken.
Ochrana všech gumových dílů.
Provonění interiéru.

Umytí exteriéru.
Chemická dekontaminace laku.
Aplikace voskové ochrany na 6 měsíců.
Oživení a ochrana plastových dílů.

Umytí kol.
Oživení pneumatik.`
  },
  {
    id: 3,
    title: "Kompletní hloubkové čištění interiéru",
    date: "10. března 2026",
    shortDesc: "Kompletní hloubkové čištění interiéru včetně tepování, čištění plastů a ošetření všech povrchů.",
    mainImage: "https://i.ibb.co/N6qc6LMt/649119365-122125434765027995-723668694493580821-n.jpg",
    detailImages: [
      "https://i.ibb.co/N6qc6LMt/649119365-122125434765027995-723668694493580821-n.jpg",
      "https://i.ibb.co/NgZRMCqd/650034729-122125434657027995-5668889117995390731-n.jpg",
      "https://i.ibb.co/BV4gX4jz/649179727-122125434645027995-569735121051721435-n.jpg",
      "https://i.ibb.co/5hQRSTF6/648985937-122125434723027995-5434044373665858521-n.jpg",
      "https://i.ibb.co/qM3MMDzk/649107009-122125434687027995-118767256243038839-n.jpg",
      "https://i.ibb.co/BV4R3Hfj/649237615-122125434627027995-2675917353428926969-n.jpg",
      "https://i.ibb.co/gLGh8VjV/649109747-122125434789027995-5831779335234361144-n.jpg",
      "https://i.ibb.co/4ZnpBJtj/648947469-122125434675027995-6868910786119059630-n.jpg",
      "https://i.ibb.co/0jD0VYv6/650159631-122125434867027995-5805088273796944987-n.jpg",
      "https://i.ibb.co/j9ydRvD4/650372054-122125434807027995-6026559537348963281-n.jpg",
      "https://i.ibb.co/3YFS5H4N/649885733-122125434735027995-668207629838383164-n.jpg",
      "https://i.ibb.co/spNFTDpg/649660914-122125434849027995-4713162730060267081-n.jpg"
    ],
    fullDesc: `Ruční mytí rámů.
Vysátí podlahy, koberečků, sedadel a kufru.
Tepování sedadel a pásů.
Čištění a ošetření plastů a přístrojové desky.
Čištění a impregnace volantu.
Mytí a leštění oken.
Vyčištění stropnice.
Provonění interiéru.
Ochrana koberečků, pedálů a gumových těsnění.`
  }
];

// Image Modal Component using React Portal
const ImageModal = ({ image, images, currentIndex, onClose, onPrev, onNext }) => {
  const modalContent = (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/95 p-4 animate-fade-in">
      {/* Close Button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 z-[10000] bg-white/10 hover:bg-white/20 backdrop-blur-xl text-white p-3 rounded-full transition-all duration-300 hover:scale-110 shadow-2xl border border-white/20"
        aria-label="Zavřít"
      >
        <X size={28} strokeWidth={2.5} />
      </button>

      {/* Previous Button */}
      {images && currentIndex > 0 && (
        <button
          onClick={onPrev}
          className="absolute left-4 z-[10000] bg-white/10 hover:bg-white/20 backdrop-blur-xl text-white p-3 rounded-full transition-all duration-300 hover:scale-110 shadow-2xl border border-white/20"
          aria-label="Předchozí"
        >
          <ChevronLeft size={32} strokeWidth={2.5} />
        </button>
      )}

      {/* Next Button */}
      {images && currentIndex < images.length - 1 && (
        <button
          onClick={onNext}
          className="absolute right-4 z-[10000] bg-white/10 hover:bg-white/20 backdrop-blur-xl text-white p-3 rounded-full transition-all duration-300 hover:scale-110 shadow-2xl border border-white/20"
          aria-label="Další"
        >
          <ChevronRight size={32} strokeWidth={2.5} />
        </button>
      )}

      {/* Image */}
      <div className="relative max-w-7xl max-h-[90vh] flex items-center justify-center">
        <img
          src={image}
          alt="Zvětšený obrázek"
          className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
          onClick={(e) => e.stopPropagation()}
        />
        
        {/* Image Counter */}
        {images && (
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-white/10 backdrop-blur-xl text-white px-4 py-2 rounded-full text-sm font-bold border border-white/20">
            {currentIndex + 1} / {images.length}
          </div>
        )}
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export const CurrentWorks = () => {
  const [works, setWorks] = useState(fallbackWorks);
  const [loading, setLoading] = useState(true);
  const [expandedWork, setExpandedWork] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const [selectedWorkImages, setSelectedWorkImages] = useState(null);

  // Načtení dat z API s fallbackem
  useEffect(() => {
    const fetchWorks = async () => {
      try {
        const response = await fetch(`${API}/admin/current-works`);
        if (response.ok) {
          const data = await response.json();
          if (data && data.length > 0) {
            setWorks(data);
            console.log('✅ Loaded works from API:', data.length);
          } else {
            console.log('⚠️ API returned empty, using fallback data');
          }
        }
      } catch (error) {
        console.log('⚠️ API error, using fallback data:', error.message);
      } finally {
        setLoading(false);
      }
    };
    
    fetchWorks();
  }, []);

  const toggleExpand = (id) => {
    setExpandedWork(expandedWork === id ? null : id);
  };

  const openImageModal = (image, images, index) => {
    setSelectedImage(image);
    setSelectedWorkImages(images);
    setSelectedImageIndex(index);
    document.body.style.overflow = 'hidden';
  };

  const closeImageModal = () => {
    setSelectedImage(null);
    setSelectedWorkImages(null);
    setSelectedImageIndex(null);
    document.body.style.overflow = 'unset';
  };

  const showPrevImage = () => {
    if (selectedImageIndex > 0) {
      const newIndex = selectedImageIndex - 1;
      setSelectedImageIndex(newIndex);
      setSelectedImage(selectedWorkImages[newIndex]);
    }
  };

  const showNextImage = () => {
    if (selectedImageIndex < selectedWorkImages.length - 1) {
      const newIndex = selectedImageIndex + 1;
      setSelectedImageIndex(newIndex);
      setSelectedImage(selectedWorkImages[newIndex]);
    }
  };

  return (
    <section id="current-works" className="py-12 sm:py-20 md:py-24 bg-gradient-to-b from-gray-50 via-white to-gray-50 relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-cyan-500/5 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16 md:mb-20">
          <div className="inline-block mb-3 sm:mb-4">
            <span className="px-4 sm:px-6 py-1.5 sm:py-2 rounded-full bg-gradient-to-r from-green-100 to-emerald-100 text-green-600 font-semibold text-xs sm:text-sm tracking-wider uppercase">
              Aktuální práce
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 mb-4 sm:mb-6 bg-gradient-to-r from-gray-900 via-blue-900 to-gray-900 bg-clip-text text-transparent px-4">
            Aktuální práce
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-4">
            Podívejte se na moji poslední práci. Klikněte na „Více" u každého příspěvku pro detailní fotografie a popis práce.
          </p>
        </div>

        {/* Works Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {works.map((work, index) => (
            <Card
              key={work.id}
              className="group hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border-0 bg-white overflow-hidden flex flex-col h-full"
              style={{
                animationDelay: `${index * 100}ms`
              }}
            >
              {/* Main Image */}
              <div className="relative h-56 sm:h-64 overflow-hidden">
                <img
                  src={work.mainImage}
                  alt={work.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 cursor-pointer"
                  onClick={() => openImageModal(work.mainImage, work.detailImages, 0)}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                
                {/* Date Badge */}
                <div className="absolute top-3 right-3 backdrop-blur-xl bg-white/20 text-white px-3 py-1.5 rounded-lg text-xs font-bold shadow-xl border border-white/20">
                  {work.date}
                </div>
              </div>

              <CardHeader>
                <CardTitle className="text-xl sm:text-2xl font-black text-gray-900 group-hover:text-blue-600 transition-colors duration-300">
                  {work.title}
                </CardTitle>
              </CardHeader>

              <CardContent className="space-y-4 flex-grow flex flex-col">
                {/* Short Description */}
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  {work.shortDesc}
                </p>

                {/* Expanded Content */}
                {expandedWork === work.id && (
                  <div className="space-y-4 animate-fade-in-up border-t border-gray-200 pt-4 mt-4">
                    {/* Full Description First */}
                    <div className="bg-gradient-to-r from-blue-50 to-cyan-50 p-4 sm:p-5 rounded-xl shadow-md">
                      <h4 className="font-bold text-gray-900 mb-3 text-base sm:text-lg">Detailní popis práce:</h4>
                      <p className="text-sm sm:text-base text-gray-800 leading-relaxed whitespace-pre-line">
                        {work.fullDesc}
                      </p>
                    </div>

                    {/* Detail Images Grid */}
                    <div className="bg-white p-3 rounded-xl">
                      <h4 className="font-bold text-gray-900 mb-3 text-sm sm:text-base">Fotografie z práce (klikněte pro zvětšení):</h4>
                      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                        {work.detailImages.map((img, idx) => (
                          <img
                            key={idx}
                            src={img}
                            alt={`${work.title} - foto ${idx + 1}`}
                            className="w-full h-28 sm:h-32 object-cover rounded-lg shadow-md hover:scale-105 hover:shadow-xl transition-all duration-300 cursor-pointer ring-2 ring-transparent hover:ring-blue-500"
                            loading="lazy"
                            onClick={() => openImageModal(img, work.detailImages, idx)}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {/* Toggle Button - Always at bottom */}
                <div className="mt-auto">
                  <Button
                    onClick={() => toggleExpand(work.id)}
                    variant="outline"
                    className="w-full border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white font-bold py-3 sm:py-4 rounded-xl transition-all duration-300 flex items-center justify-center gap-2 text-base sm:text-lg"
                  >
                    {expandedWork === work.id ? (
                      <>
                        <ChevronUp size={20} />
                        <span>Méně</span>
                      </>
                    ) : (
                      <>
                        <ChevronDown size={20} />
                        <span>Více</span>
                      </>
                    )}
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <ImageModal
          image={selectedImage}
          images={selectedWorkImages}
          currentIndex={selectedImageIndex}
          onClose={closeImageModal}
          onPrev={showPrevImage}
          onNext={showNextImage}
        />
      )}
    </section>
  );
};
